/**
 * SnackbarProvider — đọc state ui.snackbar từ Redux và hiển thị Material Snackbar.
 * Components không tự dựng Snackbar; gọi `useSnackbar().success(...)` để show.
 */
import { useEffect, useState, type ReactNode } from 'react'
import { Alert, Snackbar } from '@mui/material'

import { useAppDispatch, useAppSelector } from '@/store'
import { clearSnackbar } from '@/store/slices/uiSlice'

interface Props {
  children: ReactNode
}

export function SnackbarProvider({ children }: Props) {
  const dispatch = useAppDispatch()
  const snackbar = useAppSelector((s) => s.ui.snackbar)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (snackbar) setOpen(true)
  }, [snackbar])

  const handleClose = (_e?: unknown, reason?: string) => {
    if (reason === 'clickaway') return
    setOpen(false)
    // small delay to let exit animation finish
    window.setTimeout(() => dispatch(clearSnackbar()), 200)
  }

  return (
    <>
      {children}
      <Snackbar
        key={snackbar?.id}
        open={open && !!snackbar}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {snackbar ? (
          <Alert
            severity={snackbar.severity}
            variant="filled"
            onClose={() => handleClose()}
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        ) : undefined}
      </Snackbar>
    </>
  )
}

export default SnackbarProvider
